export default (props, vars) =>
  !!props?.['student']?.bio || !!props?.['student']?.job_goals;
